import { supabase } from '../../utils/supabase'

export class TokenManager {
  private static cachedToken: string | null = null
  private static tokenExpiry: number | null = null

  /**
   * Get current auth token, with caching to avoid repeated Supabase calls
   */
  static async getToken(): Promise<string> {
    // Return cached token if still valid
    if (this.cachedToken && this.tokenExpiry && Date.now() < this.tokenExpiry) {
      return this.cachedToken
    }

    // Fetch fresh token
    const {
      data: { session },
    } = await supabase.auth.getSession()
    const token = session?.access_token ?? ''

    // Cache token with expiry (subtract 5 minutes for safety)
    if (session?.expires_at) {
      this.cachedToken = token
      this.tokenExpiry = session.expires_at * 1000 - 5 * 60 * 1000
    }

    return token
  }

  /**
   * Clear cached token (call on logout or token refresh)
   */
  static clearToken(): void {
    this.cachedToken = null
    this.tokenExpiry = null
  }

  /**
   * Get auth headers for API requests
   */
  static async getAuthHeaders(): Promise<Record<string, string>> {
    const token = await this.getToken()
    return token ? { Authorization: `Bearer ${token}` } : {}
  }
}
